import { render, staticRenderFns } from "./AmountExpended.vue?vue&type=template&id=f25c5ac2&scoped=true&"
import script from "./AmountExpended.vue?vue&type=script&lang=js&"
export * from "./AmountExpended.vue?vue&type=script&lang=js&"
import style0 from "./AmountExpended.vue?vue&type=style&index=0&id=f25c5ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25c5ac2",
  null
  
)

export default component.exports